import { REMEMBER_ME_KEY } from "../constants/SYSTEM";

const store = (key, value) => {
  const remember = localStorage.getItem(REMEMBER_ME_KEY) === "true";
  return remember
    ? localStorage.setItem(key, value)
    : sessionStorage.setItem(key, value);
};

const retrieve = (key) => {
  const remember = localStorage.getItem(REMEMBER_ME_KEY) === "true";
  return remember ? localStorage.getItem(key) : sessionStorage.getItem(key);
};

const clear = (key) => {
  const remember = localStorage.getItem(REMEMBER_ME_KEY) === "true";
  return remember
    ? localStorage.removeItem(key)
    : sessionStorage.removeItem(key);
};

export const set = (key, value) => {
  if (!key || !value) {
    return;
  }
  if (typeof value === "object") {
    value = JSON.stringify(value);
  }
  store(key, value);
};

export const get = (key) => {
  const value = retrieve(key);
  return value ? JSON.parse(value) : null;
};

export const remove = (key) => {
  clear(key);
};
